import Icon from '@/components/shared/Icon'

export default function Footer() {
    return (
        <footer className="border-top px-4 py-3 bg-light d-flex align-items-center gap-3">
            <img
                src="/images/cde-seal.png"
                alt="California Department of Education"
                height={60}
            />
            <div>
                <div className="mb-2">
                    <span>Questions: <span className="fw-bold">CAPSDAC Support Team</span> | </span>
                    <a
                        href="https://caeducation.service-now.com/login_with_sso.do?glide_sso_id=39ee9ec21b195610297dc8866e4bcbe4"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        CAPSDAC Customer Support Portal <span style={{fontSize: "0.8em", lineHeight: "1", verticalAlign: ".2em"}}>
                            <Icon name="external"/>
                        </span>
                    </a>
                </div>
                <div className="small mb-0 text-muted">&copy; California Department of Education</div>
            </div>
        </footer>
    )
}